import type { CustomEnumValue } from '../lib/commons/appFunction'

export const compareByCustomEnumOrder = (
  indexA: number,
  indexB: number,
  isDescending: boolean
): number => {
  if (indexA < 0 && indexB < 0) return 0
  if (indexA < 0) return isDescending ? -1 : 1
  if (indexB < 0) return isDescending ? 1 : -1
  return indexA - indexB
}

// グループごとに選択肢の一部しか使われていない場合、位置をそのまま採用すると
// 異なる値が同じ順序になるため、最も上位の位置で並べ直して通し番号を振る
export const buildCustomEnumOrderMap = (
  optionsByGroup: Map<string, CustomEnumValue[]>
): Map<string, number> => {
  const highestPositions = new Map<string, number>()
  const valuesInAppearanceOrder: string[] = []
  optionsByGroup.forEach(options => {
    options.forEach((option, index) => {
      const registered = highestPositions.get(option.value)
      if (registered === undefined) {
        valuesInAppearanceOrder.push(option.value)
        highestPositions.set(option.value, index)
        return
      }
      if (index < registered) {
        highestPositions.set(option.value, index)
      }
    })
  })
  const orderMap = new Map<string, number>()
  valuesInAppearanceOrder
    .sort((a, b) => highestPositions.get(a)! - highestPositions.get(b)!)
    .forEach((value, order) => orderMap.set(value, order))
  return orderMap
}

export const customEnumOrderOf = (
  orderMap: Map<string, number>,
  value: string | undefined
): number => (value === undefined ? -1 : (orderMap.get(value) ?? -1))

export const indexOfCustomEnumValue = (
  options: CustomEnumValue[] | undefined,
  value: string | undefined
): number =>
  options && value !== undefined
    ? options.findIndex(option => option.value === value)
    : -1
